/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AmbulanzType } from './AmbulanzType';
import {
    AmbulanzTypeFromJSON,
    AmbulanzTypeFromJSONTyped,
    AmbulanzTypeToJSON,
    AmbulanzTypeToJSONTyped,
} from './AmbulanzType';

/**
 * 
 * @export
 * @interface CreateAmbulanzRequest
 */
export interface CreateAmbulanzRequest {
    /**
     * 
     * @type {AmbulanzType}
     * @memberof CreateAmbulanzRequest
     */
    type: AmbulanzType;
    /**
     * 
     * @type {string}
     * @memberof CreateAmbulanzRequest
     */
    ambulanzNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAmbulanzRequest
     */
    clientId: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAmbulanzRequest
     */
    clientName: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAmbulanzRequest
     */
    phone: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAmbulanzRequest
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateAmbulanzRequest
     */
    note: string | null;
}



/**
 * Check if a given object implements the CreateAmbulanzRequest interface.
 */
export function instanceOfCreateAmbulanzRequest(value: object): value is CreateAmbulanzRequest {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('ambulanzNumber' in value) || value['ambulanzNumber'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    return true;
}

export function CreateAmbulanzRequestFromJSON(json: any): CreateAmbulanzRequest {
    return CreateAmbulanzRequestFromJSONTyped(json, false);
}

export function CreateAmbulanzRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAmbulanzRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'type': AmbulanzTypeFromJSON(json['type']),
        'ambulanzNumber': json['ambulanzNumber'],
        'clientId': json['clientId'],
        'clientName': json['clientName'],
        'phone': json['phone'],
        'email': json['email'],
        'note': json['note'],
    };
}

export function CreateAmbulanzRequestToJSON(json: any): CreateAmbulanzRequest {
    return CreateAmbulanzRequestToJSONTyped(json, false);
}

export function CreateAmbulanzRequestToJSONTyped(value?: CreateAmbulanzRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': AmbulanzTypeToJSON(value['type']),
        'ambulanzNumber': value['ambulanzNumber'],
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'phone': value['phone'],
        'email': value['email'],
        'note': value['note'],
    };
}

